import { getInitials } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarAvatar } from './SonarAvatar';
import { useStakeholderReference } from '@hooks';

export interface StakeholderAvatarProps {
	className?: string;
	large?: boolean;
	stakeholderId: number;
}

export const StakeholderAvatar: React.FC<StakeholderAvatarProps> = ({ className, large, stakeholderId }) => {
	const { name } = useStakeholderReference(stakeholderId);
	const [ firstName, lastName ] = name?.split(' ') ?? [];
	const initials = getInitials(firstName, lastName);

	return (
		<SonarAvatar
			className={ className }
			isPlaceholder={ stakeholderId === -1 }
			large={ large }>
			{ initials }
		</SonarAvatar>
	);
};
